var map = {
	"./border-bg-sm.png": 1391,
	"./border-bg.png": 1392,
	"./btn-active.png": 1393,
	"./cny-flower-1.webp": 1394,
	"./cny-flower-2.webp": 1395,
	"./cny-mobile-bg.webp": 1396,
	"./content-deco-1.webp": 1397,
	"./content-deco-2.webp": 1398,
	"./content-deco-3.webp": 1399,
	"./content-deco-4.webp": 1400,
	"./content-deco-5.webp": 1401,
	"./deposit-icon.webp": 1402,
	"./home-icon-active.webp": 1403,
	"./home-icon.webp": 1404,
	"./live-icon-active.webp": 1405,
	"./live-icon.webp": 1406,
	"./master-bg.png": 1407,
	"./me-icon-active.webp": 1408,
	"./me-icon.webp": 1409,
	"./platform.webp": 1410,
	"./product-overview-bg.webp": 1411,
	"./promos-icon-active.webp": 1412,
	"./promos-icon.webp": 1413,
	"./sponsor-icon-active.webp": 1414,
	"./sponsor-icon.webp": 1415,
	"./title-deco-bg.webp": 1416,
	"./title-deco-left.webp": 1417,
	"./title-deco-right.webp": 1418,
	"./vip-icon-active.webp": 1419,
	"./vip-icon.webp": 1420,
	"./withdraw-icon.webp": 1421,
	"./wwr-bg.webp": 1422,
	"./wwr-img.webp": 1423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;